import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-search\"><path d=\"M291.837773 107.51918A346.685355 346.685355 0 0 0 95.999268 527.995972a346.365357 346.365357 0 0 0 399.356953 236.798193 345.725362 345.725362 0 0 0 275.1979-373.117153 345.597363 345.597363 0 0 0-343.037383-311.677622c-46.719644 0-92.799292 8.959932-135.678965 27.51979zM427.516738 0A427.196741 427.196741 0 1 1 0 427.516738C0 191.35854 191.35854 0 427.516738 0z m556.155757 1023.992188c-10.239922 0-20.479844-4.479966-28.159785-11.519913l-202.878452-202.878452a40.191693 40.191693 0 0 1 0.639995-56.31957c15.359883-15.359883 40.319692-15.999878 56.31957-0.639995l202.878452 202.878452c11.519912 11.519912 14.719888 28.79978 8.319937 43.519668-5.759956 15.359883-20.479844 24.95981-37.119717 24.95981z\" fill=\"#FFFFFF\" p-id=\"1348\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/search.svg
// module id = Bx0U
// module chunks = 27